<template>
  <BaseCard
    :key="mineral.mainProperties.idName"
    :details="`/minerals/${mineral.mainProperties.idName}`"
    class="mineralCard"
  >
    <template v-slot:front>
      <base-photo
        :image-data="
          Object.assign(mineral.mainProperties, {
            size: mineral.photoSize,
            source: '/img/minerals/' + mineral.mainProperties.idName,
          })
        "
      />

      <div class="front__identification">
        <h3 class="front__identification--name heading-3">
          {{ usingSlice(mineral.mainProperties.name) }}
        </h3>
      </div></template
    >
    <template v-slot:back>
      <div class="details__item">
        <div class="details__item--1">
          {{ mineral.mainProperties.formula.propName }}
        </div>
        <div
          class="details__item--2"
          v-html="mineral.mainProperties.formula.propValue"
        ></div>
      </div>
      <div class="details__item">
        <div class="details__item--1">
          {{ mineral.mainProperties.type.propName }}
        </div>
        <div class="details__item--2">
          {{ usingSlice(mineral.mainProperties.type.propValue) }}
        </div>
      </div>
      <div class="details__item">
        <div class="details__item--1">
          {{ mineral.mainProperties.composition.propName }}
        </div>
        <div class="details__item--2">
          {{ mineral.mainProperties.composition.propValue }}
        </div>
      </div>
      <div class="details__item">
        <div class="details__item--1">
          {{ usingSlice(mineral.mainProperties.crystal.propName) }}
        </div>
        <div class="details__item--2">
          {{ mineral.mainProperties.crystal.propValue }}
        </div>
      </div>
      <div
        class="details__item"
        v-if="mineral.mainProperties.cleavage.propValue !== 'none'"
      >
        <div class="details__item--1">
          {{ mineral.mainProperties.cleavage.propName }}
        </div>
        <div class="details__item--2">
          {{ mineral.mainProperties.cleavage.propValue }}
        </div>
      </div>
      <div class="details__item">
        <div class="details__item--1">
          {{ mineral.mainProperties.fracture.propName }}
        </div>
        <div class="details__item--2">
          {{ mineral.mainProperties.fracture.propValue }}
        </div>
      </div>
      <div class="details__item">
        <div class="details__item--1">
          {{ mineral.mainProperties.lustre.lustre }}
        </div>
        <div class="details__item--2">
          {{ mineral.mainProperties.lustre.propValue }}
        </div>
      </div>
      <div class="details__item">
        <div class="details__item--1">
          {{ mineral.mainProperties.streak.propName }}
        </div>
        <div class="details__item--2">
          {{ mineral.mainProperties.streak.propValue }}
        </div>
      </div>
      <div class="details__item">
        <div class="details__item--1">
          {{ mineral.mainProperties.hardness.propName }}:
        </div>
        <div class="details__item--2">
          {{ mineral.mainProperties.hardness.propValue[0] }}
          {{
            mineral.mainProperties.hardness.propValue[1] == "-1"
              ? ""
              : `- ${mineral.mainProperties.hardness.propValue[1]}`
          }}
        </div>
      </div>
      <div class="details__item">
        <div class="details__item--1">
          {{ mineral.mainProperties.density.propName }}:
        </div>
        <div class="details__item--2">
          {{ mineral.mainProperties.density.propValue[0] }}
          {{
            mineral.mainProperties.density.propValue[1] == "-1"
              ? ""
              : `-${mineral.mainProperties.density.propValue[1]}`
          }}
          g/cm<sup>3</sup>
        </div>
      </div>
    </template>
  </BaseCard>
</template>

<script setup>
import BaseCard from "@/components/ui/BaseCard.vue";
import BasePhoto from "@/components/ui/BasePhoto.vue";

import { defineProps } from "vue";

const mineral = defineProps(["mainProperties", "photoSize"]);

function usingSlice(str, limit = 20) {
  if (!str) return;
  if (str.length > limit) return str.slice(0, limit) + "...";
  return str;
}
</script>

<style lang="css" scoped>
.details__item {
  display: flex;
  flex-direction: row;
}
.details__item--1 {
  width: 40%;
}
.details__item--2 {
  width: 60%;
  border-bottom: 1px solid var(--color-primary-3);
}
.front__identification {
  /* grid-row: 3/4; */
  margin-top: 0.5rem;
  grid-row: 2/3;
  grid-column: 1/-1;
  display: flex;
  flex-direction: column;
}
@media only screen and (max-width: 81.25em) {
  .front__identification {
    grid-row: 2/3;
    grid-column: 1/-1;
    background-color: white;
    justify-content: center;
  }
}

.front__identification--name {
  text-transform: uppercase;
  text-align: center;
  color: var(--color-home-3);
  font-weight: 1000;
}

@media only screen and (max-width: 64em) {
  .front__identification--name {
    font-size: 1.8rem;
  }
}
@media only screen and (max-width: 47.75em) {
  .front__identification--name {
    font-size: 1.6rem;
  }
}

.front__identification--symbolHtml {
  font-family: var(--font-primary);
  color: var(--color-home-3);
  font-size: 1.4rem;
  font-weight: 400;
  width: 100%;
  height: 1.5rem;
  text-overflow: ellipsis;
  text-align: center;
}

@media only screen and (max-width: 81.25em) {
  .front__identification--symbolHtml {
    display: none;
  }
}
</style>
